module.exports = __webpack_public_path__ + "static/media/instagram.122145eb.svg";